export default __webpack_public_path__ + "fonts/a05a0d687a088c4efed303a504befad7.woff2";